import ImageTextInGridPreview from "./ImageTextInGridPreview";

export default ImageTextInGridPreview;